import React, {  useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { changeTutor, search_User ,getAsociados} from "../../redux/actions";
import { Link} from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import Swal from "sweetalert2";

const CambioTutor = ({ asociado, closeModal }) => {
  const [textSeacrch, setTextSearch] = useState("Buscar");
  const [search, setSearch] = useState("");
  const [tutor, setTutor] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [showSelect, setShowSelect] = useState(false);
  const [inputs, setInputs] = useState({
    doc: null,
    obs: "",
    terminal: "",
  });

  const dispatch = useDispatch();

  const searchTutor = async (e) => {
    e.preventDefault();
    setTextSearch("Buscando...");
    setShowForm(false);
    const body = { dni: parseInt(search), page: 1 };
    const res = await dispatch(search_User(body));
    if (res.status === 200 && res.data?.length === 1) {
      setTextSearch("Buscar");
      setShowForm(true);
      setTutor(res?.data[0]);
    }
    if (res.data?.length > 1) {
      setTutor(res?.data);
      setShowSelect(true);
      setTextSearch("Buscar");
    }
    if( res.data?.length === 0){
      Swal.fire({
        title: "No se encontro el tutor",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      setTextSearch("Buscar");
    }
  };

  const addTutorSelected = async (e) => {

    const body = { dni: parseInt(search), page: 1 };
    const res = await dispatch(search_User(body));
    if (res.status === 200) {
      setTextSearch("Buscar");
      setShowForm(true);
      setTutor(res?.data[e]);
      setShowSelect(false);
    }
  };
  // convertir en base 64
  const fileToBase64 = (file) => {
    if (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
  
        reader.readAsDataURL(file);
  
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    }else{
      return null
    }
  };

  const handleChangeTutor = async (e) => {
    e.preventDefault();
    if (!inputs.obs || !inputs.terminal) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Complete todos los campos",
      });
      return;
    }

    Swal.fire({

      text: "¿Esta seguro de realizar esta acción?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText:"Cancelar",
      confirmButtonText: "Confirmar",
    }).then(async (result) => {
      if (result.isConfirmed) {
       confirmChangeTutor()
      }
    });
  };

  const confirmChangeTutor = async (e) => {
    
    try {
      const base64Doc = await fileToBase64(inputs?.doc);
      const extend = inputs?.doc?.name?.match(/\.[^/.]+$/)[0];
    
    
    const body = {
      cuitNewTutor: tutor?.cuit,
      _id: asociado?._id,
      obs: inputs.obs,
      terminal: inputs?.terminal,
      doc: base64Doc, // base64 string
      type:extend
    };
    // Asegurate de enviar el FormData en la acción:
    const res = await dispatch(changeTutor(body));

   // console.log(body);
    if (res?.status === 200) {
      Swal.fire({
        icon: "success",
        title: "Se cambio el tutor correctamente",
        showConfirmButton: false,
        timer: 2000,
      });
     closeModal()
     await dispatch(getAsociados(1));
    } else {
      Swal.fire({
        icon: "error",
        title: res?.msg || "Ocurrio un error",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  }
    catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error al convertir el documento",
        text: "El archivo no pudo ser procesado",
      });
      return;
    }
  }
  return (
    <div className="container">
      <div className="d-flex align-items-center gap-2">
        <Link to={"/list/asociados"} onClick={closeModal}>
          <IoArrowBackCircleOutline
            style={{ fontSize: "30px", color: "orange" }}
          />
        </Link>
        <h5 className="my-4">Solicitar cambio de tutor</h5>
      </div>

      <div className="card p-4">
        <fieldset className="mb-3">
          <legend className="fs-5">Información del menor</legend>
          <p>
            <strong>Nombre:</strong>{" "}
            <span className="text-muted">
              {asociado?.name} {asociado?.lastName}
            </span>
          </p>
          <p>
            <strong>Tutor actual:</strong>{" "}
            <span className="text-muted">
              {asociado?.tutorDetails[0]?.name}{" "}
              {asociado?.tutorDetails[0]?.lastName}
            </span>
          </p>
          <p>
            <strong>DNI del tutor:</strong>{" "}
            <span className="text-muted">{asociado?.tutorDetails[0]?.dni}</span>
          </p>
        </fieldset>

        <hr style={{ border: "1.5px dotted #06799b" }} />

        <fieldset className="mb-4">
          <legend className="fs-5">Buscar nuevo tutor</legend>
          <div className="d-flex gap-3 align-items-center">
            <input
              disabled={textSeacrch === "Buscando..."}
              type="text"
              className="form-control"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Ingrese el DNI del nuevo tutor..."
              style={{ maxWidth: 300 }}
            />
            <button
              onClick={searchTutor}
              className="btn btn-primary"
              disabled={textSeacrch === "Buscando..."}
            >
              {textSeacrch}
            </button>
          </div>
        </fieldset>
        {showSelect && (
          <div className="d-flex gap-3 align-items-center">
            <p className="mt-2">Se encontraon {tutor?.length} coincidencias</p>
            <select
              className="form-select"
              style={{ width: 300 }}
              onChange={(e) => addTutorSelected(e.target.value)}
            >
              <option value="">Seleccione el tutor correspondiente</option>
              {tutor?.map((tutor, i) => (
                <option key={tutor._id} value={i}>
                  {tutor?.name} {tutor?.lastName}
                </option>
              ))}
            </select>
          </div>
        )}
        {showForm && (
          <>
            <hr style={{ border: "1.5px dotted #06799b" }} />

            <form className="mt-3">
              <fieldset>
                <legend className="fs-5">Datos del nuevo tutor</legend>
                <div className="row mb-3">
                  <div className="col">
                    <label>Nombre</label>
                    <input
                      type="text"
                      className="form-control"
                      value={tutor?.name}
                      readOnly
                      disabled
                    />
                  </div>
                  <div className="col">
                    <label>Apellido</label>
                    <input
                      type="text"
                      className="form-control"
                      value={tutor?.lastName}
                      readOnly
                      disabled
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col">
                    <label>CUIL/CUIT</label>
                    <input
                      type="text"
                      className="form-control"
                      value={tutor?.cuit}
                      readOnly
                      disabled
                    />
                  </div>

                  <div className="col">
                    <label>Correo Electrónico</label>
                    <input
                      type="email"
                      className="form-control"
                      value={tutor?.email}
                      readOnly
                      disabled
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col">
                    <label>Dirección</label>
                    <input
                      type="text"
                      className="form-control"
                      value={tutor?.address}
                      readOnly
                      disabled
                    />
                  </div>

                  <div className="col">
                    <label>Teléfono</label>
                    <input
                      type="text"
                      className="form-control"
                      value={tutor?.phoneNumber}
                      readOnly
                      disabled
                    />
                  </div>
                </div>
              </fieldset>

              <hr style={{ border: "1.5px dotted #06799b" }} />

              <fieldset>
                <legend className="fs-5">Motivo y confirmación</legend>
                <div className="mb-3">
                  <label>Motivo del cambio</label>
                  <input
                    name="obs"
                    value={inputs.obs}
                    className="form-control"
                    placeholder="Ingrese el motivo del cambio"
                    onChange={(e) => {
                      const value = e.target.value;
                      setInputs((prev) => ({ ...prev, obs: value }));
                    }}
                  />
                </div>

                <div className="mb-3">
                  <label>Documento adjunto</label>
                  <input
                    type="file"
                    accept=".pdf,.jpg,.docx,.doc,.png,.jpeg"
                    className="form-control"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                       // console.log(file)
                        setInputs((prev) => ({ ...prev, doc: file }));
                      }
                    }}
                  />
                </div>

                <div className="mb-3">
                  <label>Lugar de solicitud</label>
                  <select
                    className="form-control"
                    value={inputs.terminal}
                    name="lugar"
                    onChange={(e) => {
                      const value = e.target.value;
                      setInputs((prev) => ({ ...prev, terminal: value }));
                    }}
                  >
                    <option value="">Seleccione una opción</option>
                    <option value="Terminal de Transferencia UNaM">
                      Terminal de Transferencia UNaM
                    </option>
                    <option value="Terminal de Transferencia Quaranta">
                      Terminal de Transferencia Quaranta
                    </option>
                    <option value="Posadas Plaza Shopping">
                      Posadas Plaza Shopping
                    </option>
                  </select>
                </div>

                <button
                  onClick={(e) => handleChangeTutor(e)}
                  type="submit"
                  className="btn btn-success mt-2"
                >
                  Realizar Cambios
                </button>
              </fieldset>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default CambioTutor
